/* eslint-disable react/display-name */
import {useBvtFlagsChecker} from '@telstra-connect/utils/bvt-feature-flags'
import {BvtFeatureFlags} from '@telstra-connect/utils/bvt-feature-flags/bvt-flags'
import {mobilityAppName} from '@telstra-connect/utils/data/platform-data'
import * as React from 'react'
import {useLocation, useParams, useNavigate} from 'react-router-dom'

/** @deprecated Use `React Router hooks` instead */

type LocationType = ReturnType<typeof useLocation>
type NavigationType = ReturnType<typeof useNavigate>
type ParamType = Record<string, string>
type FlagType = Record<string, boolean>
export interface IWithRouterProps<
  L = LocationType,
  P = ParamType,
  N = NavigationType,
  F = FlagType
> {
  location: L
  params: P
  navigate: N
  isBvtFlagEnabled: F
}

/** @deprecated Use `React Router hooks` instead */
export const withRouter = <Props extends IWithRouterProps>(
  Component: React.ComponentType<Props>,
) => {
  return (props: Omit<Props, keyof IWithRouterProps>) => {
    const location = useLocation()
    const params = useParams()
    const navigate = useNavigate()
    const {isBvtFlagEnabled} = useBvtFlagsChecker({
      appName: mobilityAppName,
      bvtFlagName: BvtFeatureFlags.TEDIG8380Mpex5gSlicing,
    })
    return (
      <Component
        {...(props as Props)}
        location={location}
        params={params}
        navigate={navigate}
        isBvtFlagEnabled={isBvtFlagEnabled}
      />
    )
  }
}

export function useCustomParams<Params extends {[K in keyof Params]?: string} = object>(): Params {
  const obj = useParams<Params>()

  const newObj = {}

  for (const [key, val] of Object.entries(obj)) {
    newObj[key] = typeof val === 'string' ? decodeURIComponent(val) : val
  }

  return newObj as Params
}
